import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import SessionLoader from './components/SessionLoader';
import { refreshOAuthToken } from '../utils/api';
import AuthorizedRoute from '../components/AuthorizedRoute';
import { PageLoader } from '../components/PageWrapper';
import { appStates } from './state';
import SelectAffiliate from '../views/affiliates/Affiliates';
import Requests from '../views/requests/Requests';
import RequestDetail from '../views/requests/RequestDetail';

import WorkOrders from '../views/workorders/Workorders';
import WorkOrderDetail from '../views/workorders/WorkorderDetail';
import WorkorderEdit from '../views/workorders/WorkorderEdit';
import WorkorderCreate from '../views/workorders/WorkorderCreate';

import Rooms from '../views/rooms/Rooms';
import RoomDetail from '../views/rooms/RoomDetail';

import Settings from '../views/settings/Settings';
import About from '../views/about/About';
import Logging from '../views/logging/Logging';

import ChatRouter from '../views/chat/router';

import { Features } from '../utils';

// TODO: Move route group (request, workorder, rooms, settings) into own file
const getAppRoutes = () => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="/access/requests" />} />

    {/* Service Requests */}
    <AuthorizedRoute
      required="service_requests.list" or={() => <Redirect to="/access/workorders" />}
      exact path="/access/requests" component={Requests}
    />
    <AuthorizedRoute
      required="service_request.read" or={() => <Redirect to="/access/workorders" />}
      exact path="/access/requests/:requestId/details" component={RequestDetail}
    />

    {/* Work Orders */}
    <AuthorizedRoute
      required="work_orders.list" or={() => <Redirect to="/access/rooms" />}
      exact path="/access/workorders" component={WorkOrders}
    />
    <AuthorizedRoute
      required="work_order.read" or={() => <Redirect to="/access/rooms" />}
      exact path="/access/workorders/:workorderId/details" component={WorkOrderDetail}
    />
    <AuthorizedRoute
      required="work_order.write" or={() => <Redirect to="/access/workorders" />}
      exact path="/access/workorders/:workorderId/edit" component={WorkorderEdit}
    />
    <AuthorizedRoute
      required="work_orders.create" or={() => <Redirect to="/access/workorders" />}
      exact path="/access/workorders/create" component={WorkorderCreate}
    />

    {/* Rooms */}
    <AuthorizedRoute
      required="locations.list" or={() => <Redirect to="/access/settings" />}
      exact path="/access/rooms" component={Rooms}
    />
    <AuthorizedRoute
      required="location.read" or={() => <Redirect to="/access/settings" />}
      exact path="/access/rooms/:locationId/details" component={RoomDetail}
    />

    <Route exact path="/access/settings" component={Settings} />
    <Route exact path="/access/settings/about" component={About} />
    <Route exact path="/access/settings/logging" component={Logging} />

    <Route exact path="/affiliates" component={SelectAffiliate} />

    <Features has="chat">
      <AuthorizedRoute
        required="chat.full" or={() => <Redirect to="/" />}
        path="/access/chat" component={ChatRouter}
      />
    </Features>

    <Redirect to="/access/requests" />
  </Switch>
);

const AppRouter = ({ state }) => {
  const routesByState = () => {
    switch (state) {
      case appStates.AUTH:
        refreshOAuthToken();
        return null;

      case appStates.INITIAL:
        return <PageLoader circular />;

      case appStates.SELECT_AFFILIATE:
        return <Route component={SelectAffiliate} />;

      case appStates.READY:
        return <SessionLoader>{getAppRoutes()}</SessionLoader>;

      default:
        return null;
    }
  };

  return routesByState();
};

AppRouter.propTypes = {
  state: PropTypes.string,
};

export default AppRouter;



// WEBPACK FOOTER //
// ./src/app/router.js